import { defineComponent as _defineComponent } from 'vue';
import { ref, watch, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { EnMenu, EnMenuItem } from '../../base/EnMenu';
import { EnButton } from '../../base/EnButton';
import { useElementIds } from '../composables/useElementIds';
import { ChevronLeft, ChevronRight, ChevronDown } from 'lucide-vue-next';
import { Pagination, PaginationContent, PaginationItem, PaginationEllipsis } from '../../primitives/pagination';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnDatagridPagination',
    props: {
        hideFooter: Boolean,
        options: Object,
        footerProps: Object,
        totalItems: Number,
        updateOptions: Function,
        id: String,
    },
    emits: ['update-options'],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const { t } = useI18n();
        /**
         * A simple bar to place filter buttons in. Mainly used for EnDataGrid.
         */
        const props = __props;
        const emit = __emit;
        const paginationOptions = ref(props.options);
        if (!paginationOptions.value) {
            paginationOptions.value = {
                groupBy: [],
                itemsPerPage: 10,
                page: 1,
                sortBy: []
            };
        }
        const totalPages = computed(() => {
            if (!props.totalItems || !paginationOptions.value.itemsPerPage) {
                return 1;
            }
            return Math.ceil(props.totalItems / paginationOptions.value.itemsPerPage);
        });
        const updatePage = (newPage) => {
            emit('update-options', 'page', newPage);
        };
        const updateItemsPerPage = () => {
            paginationOptions.value.page = 1;
            emit('update-options', 'itemsPerPage', paginationOptions.value.itemsPerPage);
        };
        const itemsPerPageMenu = ref();
        function selectItemsPerPage(value) {
            paginationOptions.value.itemsPerPage = value;
            updateItemsPerPage();
            itemsPerPageMenu.value?.setOpen(false);
        }
        const { addPaginationButtonIds } = useElementIds();
        function buildId() {
            return `data-grid-items-per-page-selector-${props.id}`;
        }
        watch([() => paginationOptions.value.page, totalPages], () => {
            addPaginationButtonIds();
        });
        onMounted(() => {
            addPaginationButtonIds();
        });
        const __returned__ = { t, props, emit, paginationOptions, totalPages, updatePage, updateItemsPerPage, itemsPerPageMenu, selectItemsPerPage, addPaginationButtonIds, buildId, get EnMenu() { return EnMenu; }, get EnMenuItem() { return EnMenuItem; }, get EnButton() { return EnButton; }, get ChevronLeft() { return ChevronLeft; }, get ChevronRight() { return ChevronRight; }, get ChevronDown() { return ChevronDown; }, get Pagination() { return Pagination; }, get PaginationContent() { return PaginationContent; }, get PaginationItem() { return PaginationItem; }, get PaginationEllipsis() { return PaginationEllipsis; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
